import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
// import { immer } from "zustand/middleware/immer";
// import { current } from "immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { mergeDeepLeft } from "ramda";
import devDebug from "../Helpers/debug";
import dayjs from "dayjs";
import idbKeyvalAdapter from "./1_utility";

const initialState = {
  alboFornitoriFilters: {
    "id": "",
    "search": "",
    "title": "",
    "platform_id": "",
    "tendering_authority": "",
    "url": "",
    "short_description": "",
    "min_value": "",
    "max_value": "",
    "closing_date_start": dayjs().format("YYYY-MM-DD"),
    "closing_date_end": "",
    "publication_date_start": "",
    "publication_date_end": "",
    "nuts": "",
    "cpvs": "",
    "soa_categories": "",
    "nuts_code": "",
    "page": 1,
    "page_size": 10,
    "ordering": "-publication_date",
  },
  alboFornitoriStatus: "loading",
  alboFornitoriColumns: [],
  alboFornitori: [],
  alboFornitoriFull: {
    total_pages: 1,
    results: [],
  },
  alboFornitoriViewMode: "table",
  alboFornitoriOrderingTable: { id: "publication_date", desc: "true" },
  randomReinit: 0,
  currentController: null,
  alboFornitoriFilterModalVisible: false,
  currentTab: {}, //this is in alboFornitoriStore (which is persisted) instead of viewSupplierListNoticeStore, because the latter is not persisted
  userChoseView: false,
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useAlboFornitoriStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      setCurrentTab: (supplierListNoticeID, currentTab) => //this is in alboFornitoriStore (which is persisted) instead of viewSupplierListNoticeStore, because the latter is not persisted
        set((state) => { //the tab position is saved against each supplier list notice ID specifically. The components relying on this do a null-check to see if the ID exists and set tab to 0 if not
          state.currentTab[supplierListNoticeID] = currentTab;
        }),
      toggleAlboFornitoriColumn: (col) =>
        set((state) => {
          if (state.alboFornitoriColumns.includes(col)) {
            state.alboFornitoriColumns = state.alboFornitoriColumns.filter(column => column !== col)
          } else {
            state.alboFornitoriColumns.push(col)
          }
        }),
      resetAlboFornitoriFilters: () =>
        set((state) => {
          state.alboFornitoriFilters = {
            "id": "",
            "search": "",
            "title": "",
            "platform_id": "",
            "tendering_authority": "",
            "url": "",
            "short_description": "",
            "estimated_total_value": "",
            "closing_date_start": dayjs().format("YYYY-MM-DD"),
            "closing_date_end": "",
            "nuts": "",
            "cpvs": "",
            "soa_categories": "",
            "nuts_code": "",
          }
        }),
      setUserChoseView: (userChoseView) =>
        set((state) => {
          state.userChoseView = userChoseView;
        }),
      setAlboFornitoriFilterModalVisible: (alboFornitoriFilterModalVisible) =>
        set((state) => {
          state.alboFornitoriFilterModalVisible = alboFornitoriFilterModalVisible
        }),

      setAlboFornitoriFilters: (field, value) =>
        set((state) => {
          state.alboFornitoriFilters[field] = value
        }),
      setAlboFornitoriViewMode: (alboFornitoriViewMode) =>
        set((state) => {
          state.alboFornitoriViewMode = alboFornitoriViewMode;
        }),
      setAlboFornitoriOrderingTable: (alboFornitoriOrderingTable) =>
        set((state) => {
          state.alboFornitoriOrderingTable = alboFornitoriOrderingTable;
        }),
      setAlboFornitoriStatus: (alboFornitoriStatus) =>
        set((state) => {
          state.alboFornitoriStatus = alboFornitoriStatus;
        }),
      setCurrentController: (currentController) =>
        set((state) => {
          state.currentController = currentController;
        }),
      setAlboFornitori: (alboFornitori) =>
        set((state) => {
          state.alboFornitoriFull = alboFornitori;
          state.alboFornitori = alboFornitori.results;
        }),
      setRandomReinit: () =>
        set((state) => {
          state.randomReinit = Math.random();
        }),
      resetState: () => {
        useAlboFornitoriStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              !["currentController"].includes(
                key
              )
          )
        ),
      name: "alboFornitoriStore",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[alboFornitoriStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[alboFornitoriStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[alboFornitoriStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[alboFornitoriStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[alboFornitoriStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[alboFornitoriStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },

      onRehydrateStorage: (state) => {
        devDebug(`[alboFornitoriStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[alboFornitoriStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[alboFornitoriStore] Error during rehydration. Store name: "alboFornitoriStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[alboFornitoriStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
